import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// import iconDefinitions from 'assets/icons/icon-definitions-embed.svg';
import symbolDefinitions from 'assets/icons/symbol-definitions-embed.svg';
export var IconAndSymbolInlineEmbed = function () {
    return (_jsx(_Fragment, { children: _jsx("div", { className: 'symbols', dangerouslySetInnerHTML: { __html: symbolDefinitions } }, void 0) }, void 0));
};
